import * as yup from 'yup';

export const addFamilyMemberSchema = yup.object().shape({
  firstName: yup.string().required('Please enter a name'),
  lastName: yup.string().required('Please enter a name'),
  dob: yup.date().required('Please enter a valid date'),
  relationship: yup.string().required('Please choose one option'),
});
